import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ViewCell} from '../../ng2-smart-table';

// Ref https://akveo.github.io/ng2-smart-table/#/examples/custom-editors-viewers
@Component({
  selector: 'whitelist-action',
  template: `
  <span class="text-link font-weight-bold" (click)="onClick()" id="confirmWhitelist">Whitelist</span>
  `,
  styles: ['.text-link { cursor: pointer; }']
})
export class WhitelistActionComponent implements ViewCell, OnInit {

  renderValue: string;

  @Input() value: string | number;
  @Input() rowData: any;

  @Output() clicked: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this.renderValue = this.value.toString();
  }

  onClick() {
    this.clicked.emit(this.rowData);
  }

}